import { ForgotpasswordForm } from 'features/auth/components/forgot-password';
import { useTranslation } from 'react-i18next';
import { KlaxWelcome } from 'components/blocks/klax-welcome';

export function ForgotPasswordPage() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full max-w-[456px] flex-col gap-6">
      <KlaxWelcome title={t('FORGOT_YOUR_PASSWORD')} />
      <div className="flex gap-1">
        <div className="text-sm font-normal text-medium-emphasis">
          {t('ENTER_YOUR_REGISTERED_EMAIL')}
        </div>
      </div>
      <ForgotpasswordForm />
    </div>
  );
}
